/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddAiImportRowDto,
  AiImportBulkResponse,
  AiImportCommitResponse,
  AiImportEnrichResponse,
  AiImportEntitlementResponse,
  AiImportJobResponse,
  AiImportListJobs200,
  AiImportListJobsParams,
  AiImportPageImageResponse,
  AiImportPageResponse,
  AiImportRowResponse,
  AiImportRowsParams,
  AiImportRowsResponse,
  AiImportUploadPageBody,
  BulkAiImportRowsDto,
  CommitAiImportDto,
  CreateAiImportJobDto,
  EnrichAiImportJobDto,
  GiveAiImportConsentDto,
  ReorderAiImportPagesDto,
  UpdateAiImportJobDto,
  UpdateAiImportRowDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * در دسترس بودن، سهمیهٔ صفحه‌ها، وضعیت تأیید شرایط ارسال تصویر و ورود نیمه‌کارهٔ کاربر. هیچ اطلاعات بیماری ندارد.
 * @summary وضعیت ثبت اطلاعات از روی عکس
 */
export const aiImportEntitlement = (

 signal?: AbortSignal
) => {


      return apiClient<AiImportEntitlementResponse>(
      {url: `/api/v1/ai-import/entitlement`, method: 'GET', signal
    },
      );
    }




export const getAiImportEntitlementQueryKey = () => {
    return [
    `/api/v1/ai-import/entitlement`
    ] as const;
    }


export const getAiImportEntitlementQueryOptions = <TData = Awaited<ReturnType<typeof aiImportEntitlement>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportEntitlement>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAiImportEntitlementQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof aiImportEntitlement>>> = ({ signal }) => aiImportEntitlement(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof aiImportEntitlement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AiImportEntitlementQueryResult = NonNullable<Awaited<ReturnType<typeof aiImportEntitlement>>>
export type AiImportEntitlementQueryError = void


export function useAiImportEntitlement<TData = Awaited<ReturnType<typeof aiImportEntitlement>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportEntitlement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportEntitlement>>,
          TError,
          Awaited<ReturnType<typeof aiImportEntitlement>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportEntitlement<TData = Awaited<ReturnType<typeof aiImportEntitlement>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportEntitlement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportEntitlement>>,
          TError,
          Awaited<ReturnType<typeof aiImportEntitlement>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportEntitlement<TData = Awaited<ReturnType<typeof aiImportEntitlement>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportEntitlement>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت ثبت اطلاعات از روی عکس
 */

export function useAiImportEntitlement<TData = Awaited<ReturnType<typeof aiImportEntitlement>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportEntitlement>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAiImportEntitlementQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * مالک کلینیک اجازه می‌دهد عکس برگه‌ها برای خواندن از طریق سرور واسط بوکورا به سرویس خارجی فرستاده شود. نسخهٔ متن باید با نسخهٔ فعلی یکی باشد.
 * @summary تأیید شرایط ارسال تصویر
 */
export const aiImportGiveConsent = (
    giveAiImportConsentDto: GiveAiImportConsentDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportEntitlementResponse>(
      {url: `/api/v1/ai-import/consent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: giveAiImportConsentDto, signal
    },
      );
    }




export const getAiImportGiveConsentMutationKey = () => ['aiImportGiveConsent'] as const;

export const getAiImportGiveConsentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportGiveConsent>>, TError,AiImportGiveConsentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportGiveConsent>>, TError,AiImportGiveConsentMutationVariables, TContext> => {

const mutationKey = getAiImportGiveConsentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportGiveConsent>>, AiImportGiveConsentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  aiImportGiveConsent(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportGiveConsentMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportGiveConsent>>>
    export type AiImportGiveConsentMutationBody = GiveAiImportConsentDto
    export type AiImportGiveConsentMutationError = void
    export type AiImportGiveConsentMutationVariables = {data: GiveAiImportConsentDto}

    /**
 * @summary تأیید شرایط ارسال تصویر
 */
export const useAiImportGiveConsent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportGiveConsent>>, TError,AiImportGiveConsentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportGiveConsent>>,
        TError,
        AiImportGiveConsentMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportGiveConsentMutationOptions(options), queryClient);
    }
    /**
 * از این پس هیچ عکسی برای خواندن فرستاده نمی‌شود. ورودهایی که در حال خواندن‌اند تمام می‌شوند.
 * @summary لغو اجازهٔ ارسال تصویر
 */
export const aiImportRevokeConsent = (

 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/ai-import/consent`, method: 'DELETE', signal
    },
      );
    }




export const getAiImportRevokeConsentMutationKey = () => ['aiImportRevokeConsent'] as const;

export const getAiImportRevokeConsentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportRevokeConsent>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportRevokeConsent>>, TError,void, TContext> => {

const mutationKey = getAiImportRevokeConsentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportRevokeConsent>>, void> = () => {


          return  aiImportRevokeConsent()
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportRevokeConsentMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportRevokeConsent>>>

    export type AiImportRevokeConsentMutationError = void


    /**
 * @summary لغو اجازهٔ ارسال تصویر
 */
export const useAiImportRevokeConsent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportRevokeConsent>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportRevokeConsent>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAiImportRevokeConsentMutationOptions(options), queryClient);
    }
    /**
 * ورودهای کاربر (یا با mine=false و دسترسی settings.view، همهٔ کارکنان). فقط اطلاعات کلی، بدون محتوای برگه‌ها.
 * @summary سابقهٔ ورود اطلاعات
 */
export const aiImportListJobs = (
    params?: AiImportListJobsParams,
 signal?: AbortSignal
) => {


      return apiClient<AiImportListJobs200>(
      {url: `/api/v1/ai-import/jobs`, method: 'GET',
        params, signal
    },
      );
    }




export const getAiImportListJobsQueryKey = (params?: AiImportListJobsParams,) => {
    return [
    `/api/v1/ai-import/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getAiImportListJobsQueryOptions = <TData = Awaited<ReturnType<typeof aiImportListJobs>>, TError = void>(params?: AiImportListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportListJobs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAiImportListJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof aiImportListJobs>>> = ({ signal }) => aiImportListJobs(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof aiImportListJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AiImportListJobsQueryResult = NonNullable<Awaited<ReturnType<typeof aiImportListJobs>>>
export type AiImportListJobsQueryError = void


export function useAiImportListJobs<TData = Awaited<ReturnType<typeof aiImportListJobs>>, TError = void>(
 params: undefined |  AiImportListJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportListJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportListJobs>>,
          TError,
          Awaited<ReturnType<typeof aiImportListJobs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportListJobs<TData = Awaited<ReturnType<typeof aiImportListJobs>>, TError = void>(
 params?: AiImportListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportListJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportListJobs>>,
          TError,
          Awaited<ReturnType<typeof aiImportListJobs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportListJobs<TData = Awaited<ReturnType<typeof aiImportListJobs>>, TError = void>(
 params?: AiImportListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportListJobs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary سابقهٔ ورود اطلاعات
 */

export function useAiImportListJobs<TData = Awaited<ReturnType<typeof aiImportListJobs>>, TError = void>(
 params?: AiImportListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportListJobs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAiImportListJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * یک ورود خالی برای افزودن عکس صفحه‌ها ساخته می‌شود. هر کاربر در هر لحظه یک ورود نیمه‌کاره دارد.
 * @summary شروع یک ورود تازه
 */
export const aiImportCreateJob = (
    createAiImportJobDto: CreateAiImportJobDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportJobResponse>(
      {url: `/api/v1/ai-import/jobs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiImportJobDto, signal
    },
      );
    }




export const getAiImportCreateJobMutationKey = () => ['aiImportCreateJob'] as const;

export const getAiImportCreateJobMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportCreateJob>>, TError,AiImportCreateJobMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportCreateJob>>, TError,AiImportCreateJobMutationVariables, TContext> => {

const mutationKey = getAiImportCreateJobMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportCreateJob>>, AiImportCreateJobMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  aiImportCreateJob(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportCreateJobMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportCreateJob>>>
    export type AiImportCreateJobMutationBody = CreateAiImportJobDto
    export type AiImportCreateJobMutationError = void
    export type AiImportCreateJobMutationVariables = {data: CreateAiImportJobDto}

    /**
 * @summary شروع یک ورود تازه
 */
export const useAiImportCreateJob = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportCreateJob>>, TError,AiImportCreateJobMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportCreateJob>>,
        TError,
        AiImportCreateJobMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportCreateJobMutationOptions(options), queryClient);
    }
    /**
 * عکس (حداکثر ۱۲ مگابایت) به ورود پیش‌نویس اضافه می‌شود. تصویر پیش از ذخیره استاندارد و اطلاعات مکان آن حذف می‌شود.
 * @summary افزودن عکس یک صفحه
 */
export const aiImportUploadPage = (
    id: string,
    aiImportUploadPageBody: AiImportUploadPageBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, aiImportUploadPageBody.file);

      return apiClient<AiImportPageResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/pages`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getAiImportUploadPageMutationKey = () => ['aiImportUploadPage'] as const;

export const getAiImportUploadPageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportUploadPage>>, TError,AiImportUploadPageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportUploadPage>>, TError,AiImportUploadPageMutationVariables, TContext> => {

const mutationKey = getAiImportUploadPageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportUploadPage>>, AiImportUploadPageMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  aiImportUploadPage(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportUploadPageMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportUploadPage>>>
    export type AiImportUploadPageMutationBody = AiImportUploadPageBody
    export type AiImportUploadPageMutationError = void
    export type AiImportUploadPageMutationVariables = {id: string;data: AiImportUploadPageBody}

    /**
 * @summary افزودن عکس یک صفحه
 */
export const useAiImportUploadPage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportUploadPage>>, TError,AiImportUploadPageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportUploadPage>>,
        TError,
        AiImportUploadPageMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportUploadPageMutationOptions(options), queryClient);
    }
    /**
 * فقط پیش از شروع خواندن.
 * @summary تغییر ترتیب صفحه‌ها
 */
export const aiImportReorderPages = (
    id: string,
    reorderAiImportPagesDto: ReorderAiImportPagesDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportJobResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/pages/order`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: reorderAiImportPagesDto, signal
    },
      );
    }




export const getAiImportReorderPagesMutationKey = () => ['aiImportReorderPages'] as const;

export const getAiImportReorderPagesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportReorderPages>>, TError,AiImportReorderPagesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportReorderPages>>, TError,AiImportReorderPagesMutationVariables, TContext> => {

const mutationKey = getAiImportReorderPagesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportReorderPages>>, AiImportReorderPagesMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  aiImportReorderPages(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportReorderPagesMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportReorderPages>>>
    export type AiImportReorderPagesMutationBody = ReorderAiImportPagesDto
    export type AiImportReorderPagesMutationError = void
    export type AiImportReorderPagesMutationVariables = {id: string;data: ReorderAiImportPagesDto}

    /**
 * @summary تغییر ترتیب صفحه‌ها
 */
export const useAiImportReorderPages = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportReorderPages>>, TError,AiImportReorderPagesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportReorderPages>>,
        TError,
        AiImportReorderPagesMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportReorderPagesMutationOptions(options), queryClient);
    }
    /**
 * فقط پیش از شروع خواندن؛ عکس هم پاک می‌شود.
 * @summary حذف یک صفحه
 */
export const aiImportDeletePage = (
    id: string,
    pageId: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/ai-import/jobs/${id}/pages/${pageId}`, method: 'DELETE', signal
    },
      );
    }




export const getAiImportDeletePageMutationKey = () => ['aiImportDeletePage'] as const;

export const getAiImportDeletePageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportDeletePage>>, TError,AiImportDeletePageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportDeletePage>>, TError,AiImportDeletePageMutationVariables, TContext> => {

const mutationKey = getAiImportDeletePageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportDeletePage>>, AiImportDeletePageMutationVariables> = (props) => {
          const {id,pageId} = props ?? {};

          return  aiImportDeletePage(id,pageId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportDeletePageMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportDeletePage>>>

    export type AiImportDeletePageMutationError = void
    export type AiImportDeletePageMutationVariables = {id: string;pageId: string}

    /**
 * @summary حذف یک صفحه
 */
export const useAiImportDeletePage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportDeletePage>>, TError,AiImportDeletePageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportDeletePage>>,
        TError,
        AiImportDeletePageMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportDeletePageMutationOptions(options), queryClient);
    }
    /**
 * صفحه‌ها برای خواندن در صف قرار می‌گیرند و از سهمیه رزرو می‌شوند. صفحه‌های آماده را می‌توان پیش از تمام‌شدن بقیه بررسی کرد.
 * @summary شروع خواندن صفحه‌ها
 */
export const aiImportStartJob = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<AiImportJobResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/start`, method: 'POST', signal
    },
      );
    }




export const getAiImportStartJobMutationKey = () => ['aiImportStartJob'] as const;

export const getAiImportStartJobMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportStartJob>>, TError,AiImportStartJobMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportStartJob>>, TError,AiImportStartJobMutationVariables, TContext> => {

const mutationKey = getAiImportStartJobMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportStartJob>>, AiImportStartJobMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  aiImportStartJob(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportStartJobMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportStartJob>>>

    export type AiImportStartJobMutationError = void
    export type AiImportStartJobMutationVariables = {id: string}

    /**
 * @summary شروع خواندن صفحه‌ها
 */
export const useAiImportStartJob = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportStartJob>>, TError,AiImportStartJobMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportStartJob>>,
        TError,
        AiImportStartJobMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportStartJobMutationOptions(options), queryClient);
    }
    /**
 * پیشرفت خواندن صفحه‌ها و خلاصهٔ ردیف‌ها، بدون محتوای برگه. پنل آن را دوره‌ای می‌پرسد.
 * @summary وضعیت یک ورود
 */
export const aiImportJob = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<AiImportJobResponse>(
      {url: `/api/v1/ai-import/jobs/${id}`, method: 'GET', signal
    },
      );
    }




export const getAiImportJobQueryKey = (id: string,) => {
    return [
    `/api/v1/ai-import/jobs/${id}`
    ] as const;
    }


export const getAiImportJobQueryOptions = <TData = Awaited<ReturnType<typeof aiImportJob>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportJob>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAiImportJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof aiImportJob>>> = ({ signal }) => aiImportJob(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof aiImportJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AiImportJobQueryResult = NonNullable<Awaited<ReturnType<typeof aiImportJob>>>
export type AiImportJobQueryError = void


export function useAiImportJob<TData = Awaited<ReturnType<typeof aiImportJob>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportJob>>,
          TError,
          Awaited<ReturnType<typeof aiImportJob>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportJob<TData = Awaited<ReturnType<typeof aiImportJob>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportJob>>,
          TError,
          Awaited<ReturnType<typeof aiImportJob>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportJob<TData = Awaited<ReturnType<typeof aiImportJob>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportJob>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت یک ورود
 */

export function useAiImportJob<TData = Awaited<ReturnType<typeof aiImportJob>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportJob>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAiImportJobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * تنظیمات کلی برگه (واحد مبلغ، پزشک مسئول، …). تغییر نوع فقط یک بار و پیش از ویرایش هر ردیف ممکن است و صفحه‌ها رایگان دوباره خوانده می‌شوند.
 * @summary تنظیمات ورود یا تغییر نوع آن
 */
export const aiImportUpdateJob = (
    id: string,
    updateAiImportJobDto: UpdateAiImportJobDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportJobResponse>(
      {url: `/api/v1/ai-import/jobs/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAiImportJobDto, signal
    },
      );
    }




export const getAiImportUpdateJobMutationKey = () => ['aiImportUpdateJob'] as const;

export const getAiImportUpdateJobMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportUpdateJob>>, TError,AiImportUpdateJobMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportUpdateJob>>, TError,AiImportUpdateJobMutationVariables, TContext> => {

const mutationKey = getAiImportUpdateJobMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportUpdateJob>>, AiImportUpdateJobMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  aiImportUpdateJob(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportUpdateJobMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportUpdateJob>>>
    export type AiImportUpdateJobMutationBody = UpdateAiImportJobDto
    export type AiImportUpdateJobMutationError = void
    export type AiImportUpdateJobMutationVariables = {id: string;data: UpdateAiImportJobDto}

    /**
 * @summary تنظیمات ورود یا تغییر نوع آن
 */
export const useAiImportUpdateJob = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportUpdateJob>>, TError,AiImportUpdateJobMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportUpdateJob>>,
        TError,
        AiImportUpdateJobMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportUpdateJobMutationOptions(options), queryClient);
    }
    /**
 * عکس‌ها و اطلاعات خوانده‌شدهٔ این ورود بلافاصله پاک می‌شوند. سازندهٔ ورود، یا کسی که دسترسی ویرایش تنظیمات دارد.
 * @summary لغو و پاک کردن یک ورود
 */
export const aiImportDiscard = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/ai-import/jobs/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getAiImportDiscardMutationKey = () => ['aiImportDiscard'] as const;

export const getAiImportDiscardMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportDiscard>>, TError,AiImportDiscardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportDiscard>>, TError,AiImportDiscardMutationVariables, TContext> => {

const mutationKey = getAiImportDiscardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportDiscard>>, AiImportDiscardMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  aiImportDiscard(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportDiscardMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportDiscard>>>

    export type AiImportDiscardMutationError = void
    export type AiImportDiscardMutationVariables = {id: string}

    /**
 * @summary لغو و پاک کردن یک ورود
 */
export const useAiImportDiscard = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportDiscard>>, TError,AiImportDiscardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportDiscard>>,
        TError,
        AiImportDiscardMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportDiscardMutationOptions(options), queryClient);
    }
    /**
 * برای صفحه‌های آماده، ردیف‌های تکراری و گزینه‌های تطبیق با سوابق کلینیک محاسبه می‌شود؛ پنل تا وقتی فهرست خالی نشده دوباره می‌پرسد.
 * @summary یافتن تکراری‌ها و موارد مشابه
 */
export const aiImportEnrichJob = (
    id: string,
    enrichAiImportJobDto: EnrichAiImportJobDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportEnrichResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/enrich`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrichAiImportJobDto, signal
    },
      );
    }




export const getAiImportEnrichJobMutationKey = () => ['aiImportEnrichJob'] as const;

export const getAiImportEnrichJobMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportEnrichJob>>, TError,AiImportEnrichJobMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportEnrichJob>>, TError,AiImportEnrichJobMutationVariables, TContext> => {

const mutationKey = getAiImportEnrichJobMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportEnrichJob>>, AiImportEnrichJobMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  aiImportEnrichJob(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportEnrichJobMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportEnrichJob>>>
    export type AiImportEnrichJobMutationBody = EnrichAiImportJobDto
    export type AiImportEnrichJobMutationError = void
    export type AiImportEnrichJobMutationVariables = {id: string;data: EnrichAiImportJobDto}

    /**
 * @summary یافتن تکراری‌ها و موارد مشابه
 */
export const useAiImportEnrichJob = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportEnrichJob>>, TError,AiImportEnrichJobMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportEnrichJob>>,
        TError,
        AiImportEnrichJobMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportEnrichJobMutationOptions(options), queryClient);
    }
    /**
 * ردیف‌های یک صفحه (یا با filter، ردیف‌های همهٔ صفحه‌ها با آن وضعیت) با مقدار، وضعیت هر خانه و گزینه‌های تطبیق. هر مشاهده در گزارش فعالیت ثبت می‌شود.
 * @summary ردیف‌های خوانده‌شده برای بازبینی
 */
export const aiImportRows = (
    id: string,
    params?: AiImportRowsParams,
 signal?: AbortSignal
) => {


      return apiClient<AiImportRowsResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/rows`, method: 'GET',
        params, signal
    },
      );
    }




export const getAiImportRowsQueryKey = (id: string,
    params?: AiImportRowsParams,) => {
    return [
    `/api/v1/ai-import/jobs/${id}/rows`, ...(params ? [params] : [])
    ] as const;
    }


export const getAiImportRowsQueryOptions = <TData = Awaited<ReturnType<typeof aiImportRows>>, TError = void>(id: string,
    params?: AiImportRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportRows>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAiImportRowsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof aiImportRows>>> = ({ signal }) => aiImportRows(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof aiImportRows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AiImportRowsQueryResult = NonNullable<Awaited<ReturnType<typeof aiImportRows>>>
export type AiImportRowsQueryError = void


export function useAiImportRows<TData = Awaited<ReturnType<typeof aiImportRows>>, TError = void>(
 id: string,
    params: undefined |  AiImportRowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportRows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportRows>>,
          TError,
          Awaited<ReturnType<typeof aiImportRows>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportRows<TData = Awaited<ReturnType<typeof aiImportRows>>, TError = void>(
 id: string,
    params?: AiImportRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportRows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportRows>>,
          TError,
          Awaited<ReturnType<typeof aiImportRows>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportRows<TData = Awaited<ReturnType<typeof aiImportRows>>, TError = void>(
 id: string,
    params?: AiImportRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportRows>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ردیف‌های خوانده‌شده برای بازبینی
 */

export function useAiImportRows<TData = Awaited<ReturnType<typeof aiImportRows>>, TError = void>(
 id: string,
    params?: AiImportRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportRows>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAiImportRowsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * یک ردیف خالی در صفحه اضافه می‌شود تا کاربر خودش پر کند.
 * @summary افزودن ردیف جاافتاده
 */
export const aiImportAddRow = (
    id: string,
    addAiImportRowDto: AddAiImportRowDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportRowResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/rows`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addAiImportRowDto, signal
    },
      );
    }




export const getAiImportAddRowMutationKey = () => ['aiImportAddRow'] as const;

export const getAiImportAddRowMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportAddRow>>, TError,AiImportAddRowMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportAddRow>>, TError,AiImportAddRowMutationVariables, TContext> => {

const mutationKey = getAiImportAddRowMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportAddRow>>, AiImportAddRowMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  aiImportAddRow(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportAddRowMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportAddRow>>>
    export type AiImportAddRowMutationBody = AddAiImportRowDto
    export type AiImportAddRowMutationError = void
    export type AiImportAddRowMutationVariables = {id: string;data: AddAiImportRowDto}

    /**
 * @summary افزودن ردیف جاافتاده
 */
export const useAiImportAddRow = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportAddRow>>, TError,AiImportAddRowMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportAddRow>>,
        TError,
        AiImportAddRowMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportAddRowMutationOptions(options), queryClient);
    }
    /**
 * ثبت شوند / ثبت نشوند، تعیین یک ستون، تأیید دسته‌ها یا تعیین تطبیق برای ردیف‌های انتخاب‌شده.
 * @summary تغییر گروهی ردیف‌ها
 */
export const aiImportBulkRows = (
    id: string,
    bulkAiImportRowsDto: BulkAiImportRowsDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportBulkResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/rows/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkAiImportRowsDto, signal
    },
      );
    }




export const getAiImportBulkRowsMutationKey = () => ['aiImportBulkRows'] as const;

export const getAiImportBulkRowsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportBulkRows>>, TError,AiImportBulkRowsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportBulkRows>>, TError,AiImportBulkRowsMutationVariables, TContext> => {

const mutationKey = getAiImportBulkRowsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportBulkRows>>, AiImportBulkRowsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  aiImportBulkRows(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportBulkRowsMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportBulkRows>>>
    export type AiImportBulkRowsMutationBody = BulkAiImportRowsDto
    export type AiImportBulkRowsMutationError = void
    export type AiImportBulkRowsMutationVariables = {id: string;data: BulkAiImportRowsDto}

    /**
 * @summary تغییر گروهی ردیف‌ها
 */
export const useAiImportBulkRows = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportBulkRows>>, TError,AiImportBulkRowsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportBulkRows>>,
        TError,
        AiImportBulkRowsMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportBulkRowsMutationOptions(options), queryClient);
    }
    /**
 * فقط خانه‌های فرستاده‌شده تغییر می‌کنند. تغییر تطبیق باید updatedAt دیده‌شده را همراه داشته باشد.
 * @summary ویرایش یک ردیف
 */
export const aiImportUpdateRow = (
    id: string,
    rowId: string,
    updateAiImportRowDto: UpdateAiImportRowDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportRowResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/rows/${rowId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAiImportRowDto, signal
    },
      );
    }




export const getAiImportUpdateRowMutationKey = () => ['aiImportUpdateRow'] as const;

export const getAiImportUpdateRowMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportUpdateRow>>, TError,AiImportUpdateRowMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportUpdateRow>>, TError,AiImportUpdateRowMutationVariables, TContext> => {

const mutationKey = getAiImportUpdateRowMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportUpdateRow>>, AiImportUpdateRowMutationVariables> = (props) => {
          const {id,rowId,data} = props ?? {};

          return  aiImportUpdateRow(id,rowId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportUpdateRowMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportUpdateRow>>>
    export type AiImportUpdateRowMutationBody = UpdateAiImportRowDto
    export type AiImportUpdateRowMutationError = void
    export type AiImportUpdateRowMutationVariables = {id: string;rowId: string;data: UpdateAiImportRowDto}

    /**
 * @summary ویرایش یک ردیف
 */
export const useAiImportUpdateRow = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportUpdateRow>>, TError,AiImportUpdateRowMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportUpdateRow>>,
        TError,
        AiImportUpdateRowMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportUpdateRowMutationOptions(options), queryClient);
    }
    /**
 * نشانی امضاشدهٔ کوتاه‌مدت برای نمایش عکس کنار جدول. هر مشاهده در گزارش فعالیت ثبت می‌شود.
 * @summary نشانی عکس یک صفحه
 */
export const aiImportPageImage = (
    id: string,
    pageId: string,
 signal?: AbortSignal
) => {


      return apiClient<AiImportPageImageResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/pages/${pageId}/image`, method: 'GET', signal
    },
      );
    }




export const getAiImportPageImageQueryKey = (id: string,
    pageId: string,) => {
    return [
    `/api/v1/ai-import/jobs/${id}/pages/${pageId}/image`
    ] as const;
    }


export const getAiImportPageImageQueryOptions = <TData = Awaited<ReturnType<typeof aiImportPageImage>>, TError = void>(id: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportPageImage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAiImportPageImageQueryKey(id,pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof aiImportPageImage>>> = ({ signal }) => aiImportPageImage(id,pageId, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof aiImportPageImage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AiImportPageImageQueryResult = NonNullable<Awaited<ReturnType<typeof aiImportPageImage>>>
export type AiImportPageImageQueryError = void


export function useAiImportPageImage<TData = Awaited<ReturnType<typeof aiImportPageImage>>, TError = void>(
 id: string,
    pageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportPageImage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportPageImage>>,
          TError,
          Awaited<ReturnType<typeof aiImportPageImage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportPageImage<TData = Awaited<ReturnType<typeof aiImportPageImage>>, TError = void>(
 id: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportPageImage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aiImportPageImage>>,
          TError,
          Awaited<ReturnType<typeof aiImportPageImage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAiImportPageImage<TData = Awaited<ReturnType<typeof aiImportPageImage>>, TError = void>(
 id: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportPageImage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary نشانی عکس یک صفحه
 */

export function useAiImportPageImage<TData = Awaited<ReturnType<typeof aiImportPageImage>>, TError = void>(
 id: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof aiImportPageImage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAiImportPageImageQueryOptions(id,pageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * برای صفحه‌ای که به‌خاطر قطع ارتباط یا زمان زیاد خوانده نشد؛ از سهمیه کم نمی‌شود.
 * @summary خواندن دوبارهٔ یک صفحه
 */
export const aiImportRetryPage = (
    id: string,
    pageId: string,
 signal?: AbortSignal
) => {


      return apiClient<AiImportJobResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/pages/${pageId}/retry`, method: 'POST', signal
    },
      );
    }




export const getAiImportRetryPageMutationKey = () => ['aiImportRetryPage'] as const;

export const getAiImportRetryPageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportRetryPage>>, TError,AiImportRetryPageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportRetryPage>>, TError,AiImportRetryPageMutationVariables, TContext> => {

const mutationKey = getAiImportRetryPageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportRetryPage>>, AiImportRetryPageMutationVariables> = (props) => {
          const {id,pageId} = props ?? {};

          return  aiImportRetryPage(id,pageId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportRetryPageMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportRetryPage>>>

    export type AiImportRetryPageMutationError = void
    export type AiImportRetryPageMutationVariables = {id: string;pageId: string}

    /**
 * @summary خواندن دوبارهٔ یک صفحه
 */
export const useAiImportRetryPage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportRetryPage>>, TError,AiImportRetryPageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportRetryPage>>,
        TError,
        AiImportRetryPageMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportRetryPageMutationOptions(options), queryClient);
    }
    /**
 * حداکثر ۴۰ ردیف در هر درخواست، هر کدام از مسیر معمول همان بخش (بیماران، هزینه‌ها، …). پنل تا وقتی remaining صفر نشده ادامه می‌دهد؛ تکرار درخواست بی‌خطر است.
 * @summary ثبت ردیف‌های آماده
 */
export const aiImportCommit = (
    id: string,
    commitAiImportDto: CommitAiImportDto,
 signal?: AbortSignal
) => {


      return apiClient<AiImportCommitResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/commit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: commitAiImportDto, signal
    },
      );
    }




export const getAiImportCommitMutationKey = () => ['aiImportCommit'] as const;

export const getAiImportCommitMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportCommit>>, TError,AiImportCommitMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportCommit>>, TError,AiImportCommitMutationVariables, TContext> => {

const mutationKey = getAiImportCommitMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportCommit>>, AiImportCommitMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  aiImportCommit(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportCommitMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportCommit>>>
    export type AiImportCommitMutationBody = CommitAiImportDto
    export type AiImportCommitMutationError = void
    export type AiImportCommitMutationVariables = {id: string;data: CommitAiImportDto}

    /**
 * @summary ثبت ردیف‌های آماده
 */
export const useAiImportCommit = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportCommit>>, TError,AiImportCommitMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportCommit>>,
        TError,
        AiImportCommitMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportCommitMutationOptions(options), queryClient);
    }
    /**
 * تا ۲۴ ساعت پس از ثبت، آنچه این ورود ساخته برگردانده می‌شود (به‌جز مواردی که در این فاصله استفاده شده‌اند). بازگردانی بیماران نیازمند دسترسی حذف بیمار است.
 * @summary بازگردانی یک ورود
 */
export const aiImportUndo = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<AiImportCommitResponse>(
      {url: `/api/v1/ai-import/jobs/${id}/undo`, method: 'POST', signal
    },
      );
    }




export const getAiImportUndoMutationKey = () => ['aiImportUndo'] as const;

export const getAiImportUndoMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportUndo>>, TError,AiImportUndoMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiImportUndo>>, TError,AiImportUndoMutationVariables, TContext> => {

const mutationKey = getAiImportUndoMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiImportUndo>>, AiImportUndoMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  aiImportUndo(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiImportUndoMutationResult = NonNullable<Awaited<ReturnType<typeof aiImportUndo>>>

    export type AiImportUndoMutationError = void
    export type AiImportUndoMutationVariables = {id: string}

    /**
 * @summary بازگردانی یک ورود
 */
export const useAiImportUndo = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiImportUndo>>, TError,AiImportUndoMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiImportUndo>>,
        TError,
        AiImportUndoMutationVariables,
        TContext
      > => {
      return useMutation(getAiImportUndoMutationOptions(options), queryClient);
    }
